import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const getBaseStyles = () => {
  const { colors: color } = useContextState()

  const container: SxProps<Theme> = {
    width: '100%',
    backgroundColor: color.color5,
    borderRadius: '12px',
    boxShadow: `0 0 4px 0px ${color.color13}`,
    padding: '24px',
  }

  const headerSection: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '12px',
    mb: '16px',
  }

  const titleGroup: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  }

  const title: SxProps<Theme> = {
    fontSize: '20px',
    fontWeight: 600,
    color: color.color13,
  }

  const subtitle: SxProps<Theme> = {
    fontSize: '12px',
    color: color.color9,
    '& span': {
      color: color.color45,
      fontWeight: 500,
    },
  }

  const actionsGroup: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  }

  const textButton: SxProps<Theme> = {
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'none',
    color: color.color45,
    '&:hover': {
      backgroundColor: color.color14,
    },
  }

  const iconButton: SxProps<Theme> = {
    backgroundColor: color.color31,
    color: color.color5,
    borderRadius: '4px',
    width: '50px',
    height: '50px',
    '&:hover': {
      backgroundColor: `${color.color31}dd`,
    },
  }

  const searchIconButton: SxProps<Theme> = {
    backgroundColor: color.color10,
    color: color.color5,
    borderRadius: '4px',
    width: '50px',
    height: '50px',
    '&:hover': {
      backgroundColor: `${color.color10}dd`,
    },
  }

  const section: SxProps<Theme> = {
    width: '100%',
    p: '20px',
    mb: '16px',
    borderRadius: '6px',
    boxShadow: `0 0 2px 0px ${color.color13}`,
  }

  const cardTitle: SxProps<Theme> = {
    fontSize: '16px',
    fontWeight: 600,
    color: color.color13,
    mb: '16px',
  }

  const footerCard: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: '16px',
    flexWrap: 'wrap',
    gap: '12px',
  }

  const infoText: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: color.color9,
  }

  const consultButton: SxProps<Theme> = {
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    borderRadius: '6px',
    padding: '6px 20px',
  }

  const emptyState: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '48px 24px',
    gap: '8px',
  }

  const emptyTitle: SxProps<Theme> = {
    fontSize: '18px',
    fontWeight: 600,
    color: color.color13,
  }

  const emptyDescription: SxProps<Theme> = {
    fontSize: '14px',
    color: color.color9,
    maxWidth: '560px',
  }

  const buttons: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    padding: 1,
    '& .flex-col': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: .5
    },
    '& .red': { color: 'c_red.main' },
    '& .green': { color: 'c_green.main' },
    '& .Mui-disabled': { color: 'c_grey.100' }
  }

  return {
    container,
    headerSection,
    titleGroup,
    title,
    subtitle,
    actionsGroup,
    textButton,
    iconButton,
    searchIconButton,
    section,
    cardTitle,
    footerCard,
    infoText,
    consultButton,
    emptyState,
    emptyTitle,
    emptyDescription,
    buttons,
  }
}
